import { defineComponent as _defineComponent } from 'vue';
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-57d47000"), n = n(), _popScopeId(), n);

const _hoisted_1 = ["src"];
const _hoisted_2 = ["src"];
const _hoisted_3 = {
  class: "item__menu-title"
};
const __default__ = {
  name: 'Menu'
};
export default /*#__PURE__*/_defineComponent({ ...__default__,
  props: {
    menuList: {
      type: Array,
      default: () => []
    }
  },

  setup(__props) {
    const props = __props;
    const test = ref(0);
    return (_ctx, _cache) => {
      const _component_el_menu_item = _resolveComponent("el-menu-item");

      const _component_Menu = _resolveComponent("Menu");

      const _component_el_sub_menu = _resolveComponent("el-sub-menu");

      return _openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.menuList, menu => {
        return _openBlock(), _createElementBlock(_Fragment, null, [!menu.meta.hidden ? (_openBlock(), _createElementBlock(_Fragment, {
          key: 0
        }, [!menu.children ? (_openBlock(), _createBlock(_component_el_menu_item, {
          key: 0,
          index: menu.path,
          class: "menu-item"
        }, {
          default: _withCtx(() => [menu.meta.logo != undefined && menu.meta.logo.length > 0 ? (_openBlock(), _createElementBlock("img", {
            key: 0,
            class: "logo",
            src: menu.meta.logo
          }, null, 8, _hoisted_1)) : _createCommentVNode("", true), _createElementVNode("span", {
            class: _normalizeClass(['item__menu-title', !menu.children && menu.meta.logo ? 'noMargin' : ''])
          }, _toDisplayString(_ctx.$t(menu.meta.title)), 3)]),
          _: 2
        }, 1032, ["index"])) : (_openBlock(), _createBlock(_component_el_sub_menu, {
          key: 1,
          index: menu.path,
          class: _normalizeClass(["sub-menu-item", menu.meta.logo ? '' : 'notlogo'])
        }, {
          title: _withCtx(() => [menu.meta.logo != undefined && menu.meta.logo.length > 0 ? (_openBlock(), _createElementBlock("img", {
            key: 0,
            class: "logo",
            src: menu.meta.logo
          }, null, 8, _hoisted_2)) : _createCommentVNode("", true), _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.$t(menu.meta.title)), 1)]),
          default: _withCtx(() => [_createVNode(_component_Menu, {
            "menu-list": menu.children
          }, null, 8, ["menu-list"])]),
          _: 2
        }, 1032, ["index", "class"]))], 64)) : _createCommentVNode("", true)], 64);
      }), 256);
    };
  }

});